/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TargetRadialIcon24Solid = forwardRef('TargetRadialIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 12a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm6-3.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12.007c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10Zm10-7.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Z" })));
});
